import * as yup from 'yup'

export const addCategorySchema = yup.object({
	name: yup.string().required(),
})
